import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import * as CONFIG from 'constants/config';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import Select from 'components/Select';
import UserItem from 'pages/UsersPage/UserItem';
import { AuthContext } from 'AuthProvider';

import { getAllUserAnswers } from 'backend/UserAnswer';

const RatingListPage = () => {
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const lang = getLanguage();

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
   // if (totalUsers === 0) {
      getAllUserAnswers()
        .then((result) => {
          setTotalUsers(result.totalUser);
          /*const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);

          setUsers(getUsersByPage(result));*/
        })
        .catch((error) => {
          console.log('error', error);
          setUsers([]);
        });
    //}
  }, []);


  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const getUsersByPage = (items) => {
    let result = [];
    let i = 0;
    const fromPage = (currentPage - 1) * CONFIG.COUNT_PER_PAGE;
    const toPage = currentPage * CONFIG.COUNT_PER_PAGE;
    items.map((element) => {
      if (i >= fromPage && i < toPage) {
        result.push(element);
      }
      i++;
    })

    return result;
  };

  let pageBlock = [];
  if (pages > 1) {
    let arr = [];
    for (let i = 1; i <= pages; i++) {
      arr.push({page: i});
    }
    pageBlock = arr.map((element) => {
      if (currentPage === element.page) {
        return <button className="btn btn-light active" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      } else {
        return <button className="btn btn-light" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      }
    });
  }

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="rating" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Рейтинг</li>
              </ul>
            </div>
            <div className="page-content">
            <div className="row">
						  	<div className="col-xs-12 text-right">
                  <b>Всего пользователей принимавших участие:</b> {totalUsers}
                </div>
              </div>
              <div className="row">
						  	<div className="col-xs-12">
								  <table id="simple-table" className="table  table-bordered table-hover">
									  <thead>
                          <tr>
                            <th>#</th>
                            <th>Дата</th>
                            <th>К-во авторизированных пользователей</th>
                            <th>К-во НЕ авторизированных пользователей</th>
                            <th></th>
                          </tr>
										</thead>
										<tbody>
                          {users.map((element, index) => {
                            return (<UserItem
                              user={element}
                              key={index}
                              index={index}
                              currentPage={currentPage}
                            />);
                          })}
                    </tbody>
								  </table>
                  <div className="btn-group">
                    {pageBlock}
                  </div>
								</div>
						  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingListPage;
